Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableRow = void 0;

var core_1 = require("@emotion/core");

var core_2 = require("@wheelroom/core");

var table_row_cell_1 = require("./table-row-cell");

exports.TableRow = function (props) {
  var _a, _b;

  var tableRow = props.tableRow;

  if (!tableRow) {
    return null;
  }

  var rowHeaderCellStyle = props.wheel.style.th;
  var headerCellWidth = props.maxRowTopics ? 2 / (props.maxRowTopics + 2) : 1;
  var dataCellWidth = props.maxRowTopics ? 1 / (props.maxRowTopics + 2) : 0;

  if (!(rowHeaderCellStyle.ncss.w || rowHeaderCellStyle.ncss.width)) {
    rowHeaderCellStyle.ncss.w = headerCellWidth;
  }

  var switchVariable = tableRow.variation ? tableRow.variation + 'Variation' : 'bodyVariation';
  var colSpan = {};

  if ((tableRow.heading || tableRow.abstract || tableRow.actions || tableRow.icon) && ((_a = tableRow.topics) === null || _a === void 0 ? void 0 : _a.length) === undefined) {
    colSpan = {
      colspan: props.maxRowTopics + 1
    };
  }

  return core_1.jsx(core_2.Tr, {
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: core_2.getNcssSwitch(props.wheel.style, switchVariable)
    })
  }, core_1.jsx(core_2.Th, Object.assign({}, colSpan, {
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: rowHeaderCellStyle
    })
  }), tableRow.icon && core_1.jsx(core_2.Icon, {
    icon: tableRow.icon,
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.icon
    })
  }), core_1.jsx(core_2.Dl, {
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.dl
    })
  }, tableRow.heading && core_1.jsx(core_2.Dt, {
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.dt
    })
  }, tableRow.heading), tableRow.abstract && core_1.jsx(core_2.Dd, {
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.dd
    })
  }, (_b = tableRow.abstract) === null || _b === void 0 ? void 0 : _b.abstract)), tableRow.actions && core_1.jsx(core_2.Any, {
    is: "div",
    role: "group",
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.actionGroup
    })
  }, tableRow.actions.map(function (action, index) {
    return core_1.jsx(core_2.Action, Object.assign({
      key: index,
      url: action.url,
      page: action.page,
      icon: action.icon,
      wheel: Object.assign(Object.assign({}, props.wheel), {
        style: props.wheel.style.action
      })
    }, action));
  }))), (tableRow.topics || []).map(function (topic, index) {
    return core_1.jsx(table_row_cell_1.TableRowCell, {
      data: props.data,
      dataCellWidth: dataCellWidth,
      key: index,
      topic: topic,
      topicOptions: props.topicOptions,
      wheel: props.wheel
    });
  }));
};